import React from 'react';
import '../../public/css/PartTime.css';
import { Link } from 'react-router-dom';

function Developer() {
    return (
        <div className='cv'>
            <div className='header'>
                <h1>양준형</h1>
                <p>경기도 고양시 덕양구 행신동 &nbsp;▪&nbsp; 010-9164-1201 &nbsp;▪&nbsp; y.junh0y@gmail.com</p>
                <Link to="https://junh0y.github.io/Portfolio/" target='_blank'>
                    <img src={ require('../../images/QR-Code.png') } alt='Portfolio QR Code' />
                    <p>Portfolio</p>
                </Link>
            </div>
            <div className='content'>
                <div className='each'>
                    {/* <p className='title'>자기소개</p> */}
                    <div className='description'>
                        <div className="eachDescription">
                            <div className="main">
                                <p>&nbsp;안녕하세요. 풀스택 개발자 양준형입니다. JAVA 풀스택 과정 수료 후 2년간 PHP, Laravel를 이용하여 화장품 플랫폼 사이트를 구축했습니다. 해당 플랫폼 개발 중 가장 주목할만한 사례는 이전의 경력을 바탕으로 <span class="bold">웹 기획, DB 설계, 백엔드(API 개발)</span>을 담당한 점입니다. 또한, PHP로 개발했던 경험을 살려 아일랜드에서는 웹 에이전시에서 워드프레스 개발자로 근무했습니다. 현재는 프론트엔드 관련 기술을 익히기 위해 인디 뮤지션을 대상으로 한 플랫폼을 React, Next.js, TypeScript를 이용하여 사이드 프로젝트로 개발하고 있습니다.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Experience */}
                <div className='each'>
                    <p className='title'>경력사항</p>
                    <div className='description'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Arrow Design</span>
                                    <span>Software Architect</span>
                                    <span>아일랜드 더블린</span>
                                </div>
                                <div className='date'>
                                    <span>2024.08 - 2025.03</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>워드프레스 기반 웹 사이트 및 이커머스 개발</li>
                                    <li>커스텀 테마/플러그인 개발 및 유지보수</li>
                                    <li>MySQL을 이용한 데이터베이스 설계</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>씨티케이</span>
                                    <span>풀스택 개발</span>
                                    <span>대한민국 서울</span>
                                </div>
                                <div className='date'>
                                    <span>2022.04 - 2024.04</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>PHP(Laravel), Vue.js를 이용한 4개 웹 사이트 풀스택 개발 및 유지보수 - 본사, 화장품 플랫폼, 파트너 및 어드민 사이트 </li>
                                    <li>화장품 원료 규제 시스템 개발 - 기획, 데이터베이스 설계, 서드파티 API 활용 및 API 개발 및 프론트엔드 개발</li>
                                    <li>반응형 웹 및 모바일 최적화 - Figma 소통</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>이너보틀</span>
                                    <span>선임 연구원</span>
                                    <span>대한민국 성남</span>
                                </div>
                                <div className='date'>
                                    <span>2019.06 - 2021.06</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>친환경 화장품 패키지 개발 및 상용성 테스트/품질 관리</li>
                                    <li className='point'>화장품 원료 테스트를 경험을 바탕으로 씨티케이에서 화장품 성분 규제 분석 시스템 개발</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Experience */}
                <div className='each'>
                    <p className='title'>프로젝트</p>
                    <div className='description'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>뮤지직</span>
                                    <span>프론트엔드 개발</span>
                                    <span>대한민국</span>
                                </div>
                                <div className='date'>
                                    <span>2024.12 - </span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>인디 뮤지션들의 소통 및 홍보를 위한 플랫폼</li>
                                    <li>React, Next.js 및 TypeScript를 이용한 웹 사이트 개발<Link to='https://musizic.com' target='_blank'> (https://musizic.com)</Link> </li>
                                    <li>Figma를 통한 웹 기획, 디자인 및 UI/UX 개선</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Skills */}
                <div className='each'>
                    <p className='title'>기술</p>
                    <div className='description'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>프로그래밍</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>프론트엔드 : HTML, CSS, JavaScript, jQuery, Vue, React, Next.js, TypeScript, Front-end Libraries (Bootstrap, GASP, ...)</li>
                                    <li>백엔드 : PHP (Laravel), WordPress (테마 & 플러그인 개발), MySQL</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>언어</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>한국어 (Native), 영어 (Intermediate)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Education */}
                <div className='each'>
                    <p className='title'>교육사항</p>
                    <div className='description'>
                         <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>한국소프트웨어인재개발원</span>
                                    <span>대한민국 서울</span>
                                </div>
                                <div className='date'>
                                    <span>2021.09 - 2022.03</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>JAVA 풀스택 개발 과정 수료</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>홍익대학교</span>
                                    <span>대한민국 서울</span>
                                </div>
                                <div className='date'>
                                    <span>2010.03 - 2017.02</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>기계시스템디자인공학 학사 (부전공: 도예유리)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Link */}
                <div className='each'>
                    <p className='title'>링크</p>
                    <div className='description linkList'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>포트폴리오</span>
                                    <span><Link to='https://junh0y.github.io/Portfolio/'>https://junh0y.github.io/Portfolio/</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>링크드인</span>
                                    <span><Link to='https://www.linkedin.com/in/jun-hyeong-yang-95246b126/'>https://www.linkedin.com/in/jun-hyeong-yang-95246b126/</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>깃허브</span>
                                    <span><Link to='https://github.com/junh0y'>https://github.com/junh0y</Link></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default Developer